import Chart from 'chart.js';

export class ChartBase {
    protected canvasId: string;
    protected configuration: Chart.ChartConfiguration;
    private currentContainer: JQuery;
    private chartInstance: Chart;

    constructor(private c: JQuery) {
        this.currentContainer = c;
        Chart.defaults.global.defaultFontColor = '#544615';
        Chart.defaults.global.defaultFontFamily = 'Arial';
        Chart.defaults.global.tooltips.backgroundColor = '#0a2c54';
        Chart.defaults.global.tooltips.cornerRadius = 2;
        Chart.defaults.global.tooltips.displayColors = false;

        this.configuration = {
            data: {
                labels: [],
                datasets: [],
            },
            options: {
                tooltips: {
                    backgroundColor: "#ffffff",
                    borderColor: "#E4E5F2",
                    borderWidth: 2,
                    titleFontColor: "#000000",
                    bodyFontColor: "#000000",
                    yPadding: 10,
                    xPadding: 15,
                },
                elements: {
                    line: {
                        borderWidth: 4,
                        fill: false,
                    },
                    point: {
                        radius: 6,
                        backgroundColor: "#ffffff",
                        borderWidth: 3,
                        borderColor: "#00AA50"
                    }
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            drawBorder: false,
                            lineWidth: 1.8,
                            color: 'rgba(0,0,0,0.05)',
                        },
                        ticks: {
                            fontColor: 'black',
                            fontSize: 15,
                            padding: 7,
                            source: 'auto'
                        },
                        scaleLabel: {
                            fontColor: 'rgb(0,0,0)',
                        },
                    }],
                    yAxes: [{
                        gridLines: {
                            color: 'rgba(0,0,0,0.05)',
                        },
                    }]
                }
            }
        };
    }

    protected drawChart() {
        if (this.chartInstance != null) {
            //update chart with new configuration
            this.chartInstance.options = { ...this.configuration.options };
            this.chartInstance.data = { ...this.configuration.data };
        } else {
            //create new chart.
            var ctx = (<HTMLCanvasElement>document.getElementById(this.canvasId)).getContext('2d');
            this.chartInstance = new Chart(ctx, this.configuration);
        }

        return this.chartInstance;
    }

    protected setZeroPointRadiusForEmptyDates() {
        let that = this;
        this.chartInstance.data.datasets.forEach(function (dataset, i) {
            var meta = that.chartInstance.getDatasetMeta(i);
            let pointRadius: number[] = [];
            let defaultRadius = dataset.pointRadius as number;
            meta.data.forEach(function (bar, index) {

                var data = dataset.data[index];
                if (data === 0) {
                    pointRadius.push(0);
                } else {
                    pointRadius.push(defaultRadius);
                }
            });
            dataset.pointRadius = pointRadius;
        });

        this.chartInstance.update()
    }

    protected configurationHideXY() {
        return {
            xAxes: [{
                gridLines: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false
                },
            }],
            yAxes: [{
                gridLines: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false
                },
            }]
        };
    }
}